module.exports = __webpack_public_path__ + "static/media/add_file.41bb8dd9.svg";